import { InjectionToken } from '@angular/core';

/**
 * Bridge to AngularJS `$timeout`.
 *
 * `UtilsService.debounce` returns a `$q` promise to AngularJS consumers, so the
 * timer that drives it must still be `$timeout` to keep digest integration
 * (digest fires after each scheduled callback). Swapping to native
 * `setTimeout` would break view updates that hang off the returned promise.
 */
export interface ITimeoutPromise<T = unknown> extends Promise<T> {}

export interface ITimeoutPort {
  <T>(fn: () => T, delay: number): ITimeoutPromise<T>;
  cancel(promise: ITimeoutPromise | undefined): boolean;
}

export const TIMEOUT_PORT = new InjectionToken<ITimeoutPort>('TIMEOUT_PORT');
